// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"064845c7","166":"dda12b4f","199":"717b2673","201":"322d6102","223":"4f299e4d","452":"4f952478","453":"a8bbf14c","469":"8bf82136","650":"0bc8c347","795":"720297ad","863":"dc7e4aa4","885":"c31cc9ab"}[chunkId] + ".chunk.js";
};